module.exports = __webpack_public_path__ + "img/facebook-instruction.e5121c6e.png";